import { useState, useEffect } from "react";
import { Form } from "reactstrap";
import { APIMS } from "../../../../../../../../config/apims";
import { APISD } from "../../../../../../../../config/apisd";
import Modal from "react-bootstrap/Modal";
import { useMutation } from "react-query";
import "bulma/css/bulma.css";
import "../../../../../../../../index.css";
import ToastError from "../../../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../../../NotificationToast/ToastSuccess";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

/* ===========================
   CSS
=========================== */
const css = `
  .tingkatan-kelas-wrapper {
    margin-top: 8px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px 35px;
  }

  .tingkatan-box {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .tingkatan-parent {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    cursor: pointer;
    white-space: nowrap;
  }

  .kelas-child-wrapper {
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    gap: 7px;
  }

  .kelas-child {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    cursor: pointer;
    white-space: nowrap;
  }

  .tingkatan-parent input,
  .kelas-child input {
    width: 14px;
    height: 14px;
    cursor: pointer;
  }

  /* TABLET / HP */
  @media (max-width: 768px) {
    .tingkatan-kelas-wrapper {
      grid-template-columns: repeat(2, 1fr);
      gap: 14px 20px;
    }
  }

  /* HP KECIL BANGET */
  @media (max-width: 380px) {
    .tingkatan-kelas-wrapper {
      grid-template-columns: 1fr;
      gap: 14px;
    }
  }

  .matpel-grade-panel {
    margin-top: 8px;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    padding: 15px;
    background: #f8fafc;
  }

  .matpel-form-helper {
    margin-top: 7px;
    color: #64748b;
    font-size: 12px;
    line-height: 1.5;
  }

  .tingkatan-box {
    border: 1px solid #e5eaf1;
    border-radius: 12px;
    padding: 12px;
    background: #ffffff;
  }

  .tingkatan-parent {
    color: #1e293b;
    font-weight: 700;
  }

  .kelas-child {
    color: #475569;
  }

  .tingkatan-parent input,
  .kelas-child input {
    accent-color: #3f5bea;
  }

  @media (max-width: 576px) {
    .tingkatan-kelas-wrapper {
      grid-template-columns: 1fr;
    }

    .matpel-grade-panel {
      padding: 12px;
    }
  }

`;

export default function ModalTAUpdate(props) {
  const token = localStorage.getItem("token");

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);

  const ascending = 1;
  const page = 1;
  const limit = 1000;

  const storageLevel = localStorage.getItem("level") || "developer";

  
  const [getDataCabang, setGetDataCabang] = useState([]);
   const [getDataMatpel, setGetMatpel] = useState([]);
  const [gradeLevels, setGradeLevels] = useState([]);
  const [kelasList, setKelasList] = useState([]);

  const fetchParams = {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };

  const id_user = localStorage
    .getItem("id_admin")
    ?.replace(/[|&;$%@"<>()+,]/g, "");

  const [form, setForm] = useState({
    ysb_branch_id: "",
    name_matpel: "",
    ysb_grade_level_id: [],
    ysb_kelas_id: [],
    user_id: "",
  });

  const { name_matpel, ysb_branch_id, ysb_grade_level_id, ysb_kelas_id } = form;

  const safeStr = (v) => (v === null || v === undefined ? "" : String(v));

  const toTitleCase = (value) => {
    const s = safeStr(value).toLowerCase().trim();
    if (!s) return "";
    return s.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1));
  };

  const sortByLevelName = (a, b) => {
    const nameA = Number(a?.name_level);
    const nameB = Number(b?.name_level);

    if (!isNaN(nameA) && !isNaN(nameB)) {
      return nameA - nameB;
    }

    return String(a?.name_level || "").localeCompare(
      String(b?.name_level || ""),
      "id",
      { numeric: true }
    );
  };

  const sortByKelasName = (a, b) => {
    const nameA = a?.name_kelas || a?.kelas_name || a?.name || "";
    const nameB = b?.name_kelas || b?.kelas_name || b?.name || "";

    return String(nameA).localeCompare(String(nameB), "id", {
      numeric: true,
      sensitivity: "base",
    });
  };

  const getGradeIdFromKelas = (kelas) => {
    return (
      kelas?.ysb_grade_level_id ||
      kelas?.grade_level_id ||
      kelas?.gradeLevelId ||
      kelas?.grade_level?.id ||
      kelas?.ysb_grade_level?.id ||
      ""
    );
  };

  const getKelasName = (kelas) => {
    return kelas?.name_kelas || kelas?.kelas_name || kelas?.name || "-";
  };

  // const getSelectedKelasFromRow = (row) => {
  //   const kelasIds = [];

  //   (row?.grade_levels || []).forEach((level) => {
  //     (level?.kelas || []).forEach((kelas) => {
  //       const kelasId =
  //         kelas?.ysb_kelas_id ||
  //         kelas?.id ||
  //         kelas?.kelas_id;

  //       if (kelasId) {
  //         kelasIds.push(kelasId);
  //       }
  //     });
  //   });

  //   return Array.from(new Set(kelasIds));
  // };

 
//   const getSelectedKelasFromRow = (row) => {
//   const kelasIds = [];

//   (row?.grade_levels || []).forEach((level) => {
//     (level?.kelas || []).forEach((kelas) => {
//       const kelasId =
//         kelas?.ysb_kelas_id ||
//         kelas?.id ||
//         kelas?.kelas_id;

//       if (!kelasId) return;

//       // kelas dianggap aktif kalau minimal ada 1 semester dengan state_form = 1
//       const hasActiveSemester = (kelas?.semesters || []).some(
//         (semester) => String(semester?.state_form) === "1"
//       );

//       if (hasActiveSemester) {
//         kelasIds.push(kelasId);
//       }
//     });
//   });

//   return Array.from(new Set(kelasIds));
// };

const getSelectedKelasFromRow = (row) => {
  const kelasIds = [];

  (row?.grade_levels || []).forEach((level) => {
    const levelId =
      level?.ysb_grade_level_id ||
      level?.id ||
      level?.grade_level_id;

    if (
      props?.gradeLevelId &&
      String(levelId) !== String(props.gradeLevelId)
    ) {
      return;
    }

    (level?.kelas || []).forEach((kelas) => {
      const kelasId =
        kelas?.ysb_kelas_id ||
        kelas?.id ||
        kelas?.kelas_id;

      if (!kelasId) return;

      const schoolId =
        kelas?.ysb_school_id ||
        kelas?.school_id ||
        kelas?.school?.id ||
        "";

      if (
        props?.schoolId &&
        schoolId &&
        String(schoolId) !== String(props.schoolId)
      ) {
        return;
      }

      const hasActiveSemester = (kelas?.semesters || []).some(
        (semester) => String(semester?.state_form) === "1"
      );

      if (hasActiveSemester) {
        kelasIds.push(kelasId);
      }
    });
  });

  return Array.from(new Set(kelasIds));
};


  // const getSelectedGradeFromRow = (row) => {
  //   const gradeIds = [];

  //   (row?.grade_levels || []).forEach((level) => {
  //     const gradeId =
  //       level?.ysb_grade_level_id ||
  //       level?.id ||
  //       level?.grade_level_id;

  //     if (gradeId) {
  //       gradeIds.push(gradeId);
  //     }
  //   });

  //   return Array.from(new Set(gradeIds));
  // };

//   const getSelectedGradeFromRow = (row) => {
//   const gradeIds = [];

//   (row?.grade_levels || []).forEach((level) => {
//     const gradeId =
//       level?.ysb_grade_level_id ||
//       level?.id ||
//       level?.grade_level_id;

//     if (!gradeId) return;

//     const hasActiveKelas = (level?.kelas || []).some((kelas) =>
//       (kelas?.semesters || []).some(
//         (semester) => String(semester?.state_form) === "1"
//       )
//     );

//     if (hasActiveKelas) {
//       gradeIds.push(gradeId);
//     }
//   });

//   return Array.from(new Set(gradeIds));
// };


const getSelectedGradeFromRow = (row) => {
  const gradeIds = [];

  (row?.grade_levels || []).forEach((level) => {
    const gradeId =
      level?.ysb_grade_level_id ||
      level?.id ||
      level?.grade_level_id;

    if (!gradeId) return;

    if (
      props?.gradeLevelId &&
      String(gradeId) !== String(props.gradeLevelId)
    ) {
      return;
    }

    const hasActiveKelas = (level?.kelas || []).some((kelas) => {
      const schoolId =
        kelas?.ysb_school_id ||
        kelas?.school_id ||
        kelas?.school?.id ||
        "";

      if (
        props?.schoolId &&
        schoolId &&
        String(schoolId) !== String(props.schoolId)
      ) {
        return false;
      }

      return (kelas?.semesters || []).some(
        (semester) => String(semester?.state_form) === "1"
      );
    });

    if (hasActiveKelas) {
      gradeIds.push(gradeId);
    }
  });

  return Array.from(new Set(gradeIds));
};
  const getBranchFromRow = (row) => {
    return (
      row?.ysb_branch_id ||
      row?.branch_id ||
      row?.branch_code ||
      ""
    );
  };

  const getMatpelIdFromRow = (row) => {
    return (
      row?.ysb_matpel_id ||
      row?.matpel_id ||
      row?.ysb_subject_id ||
      ""
    );
  };

  const GetResponseCabang = async () => {
    try {
      const response = await APIMS.get(
        `/api/branches?page=1&limit=1000&ascending=${ascending}&search=`,
        fetchParams
      );

      setGetDataCabang(response?.data?.data || []);
    } catch (error) {
      console.error("Gagal mengambil data cabang:", error);
      setGetDataCabang([]);
    }
  };

  const GetResponseMatpels = async (selectedBranchId = "") => {
  if (!selectedBranchId) {
    setGetMatpel([]);
    return;
  }

  try {
    const response = await APISD.get(`/api/matpels`, {
      ...fetchParams,
      params: {
        page: 1,
        limit: 10000,
        ascending: ascending,
        search: "",
        ysb_branch_id: selectedBranchId,
      },

      // kalau endpoint GET ini baca body seperti Postman
      data: {
        page: 1,
        limit: 10000,
        ascending: ascending,
        search: "",
        ysb_branch_id: selectedBranchId,
      },
    });

    const rows = response?.data?.data || [];

    setGetMatpel(
      rows.sort((a, b) =>
        String(a?.name_matpel || "").localeCompare(
          String(b?.name_matpel || ""),
          "id",
          {
            numeric: true,
            sensitivity: "base",
          }
        )
      )
    );
  } catch (error) {
    console.error("Gagal mengambil data matpel:", error);
    setGetMatpel([]);

    ToastError.fire({
      icon: "error",
      title: "Gagal mengambil data mata pelajaran",
    });
  }
};

  useEffect(() => {
    setGetMatpel([]);
  }, []);

  const getGradeLevelsAndKelas = async (selectedBranchId) => {
    if (!selectedBranchId) {
      setGradeLevels([]);
      setKelasList([]);
      return;
    }

    try {
      setLoading(true);

      const [gradeResponse, kelasResponse] = await Promise.all([
        APIMS.get(
          `/api/grade-levels?page=${page}&limit=${limit}&ascending=${ascending}&branch=${selectedBranchId}&level=${storageLevel}`,
          fetchParams
        ),
        APIMS.get(
          `/api/kelas?page=${page}&limit=${limit}&ascending=${ascending}&branch=${selectedBranchId}&level=${storageLevel}`,
          fetchParams
        ),
      ]);

      const dataGrade = gradeResponse?.data?.data || [];
      const dataKelas = kelasResponse?.data?.data || [];

      const filteredGrade = dataGrade
        .filter((item) => {
          const branchValue =
            item?.ysb_branch_id ||
            item?.branch ||
            item?.branch_code ||
            item?.branch_id;

          return !branchValue || branchValue === selectedBranchId;
        })
        .sort(sortByLevelName);

      const filteredKelas = dataKelas
        .filter((item) => {
          const branchValue =
            item?.ysb_branch_id ||
            item?.branch ||
            item?.branch_code ||
            item?.branch_id;

          return !branchValue || branchValue === selectedBranchId;
        })
        .sort(sortByKelasName);

      setGradeLevels(filteredGrade);
      setKelasList(filteredKelas);
    } catch (error) {
      console.error("Gagal mengambil data tingkatan / kelas:", error);

      setGradeLevels([]);
      setKelasList([]);

      ToastError.fire({
        icon: "error",
        title: "Gagal mengambil data tingkatan / kelas",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetResponseCabang();
  }, []);

  // useEffect(() => {
  //   if (!props?.show) return;

  //   const row = props?.rowData || {};

  //   const branchId = getBranchFromRow(row);
  //   const selectedGradeIds = getSelectedGradeFromRow(row);
  //   const selectedKelasIds = getSelectedKelasFromRow(row);

  //   setForm({
  //     ysb_branch_id: branchId,
  //     name_matpel: props?.nameUpdate || row?.name_matpel || "",
  //     ysb_grade_level_id: selectedGradeIds,
  //     ysb_kelas_id: selectedKelasIds,
  //     user_id: "",
  //   });

  //   if (branchId) {
  //     getGradeLevelsAndKelas(branchId);
  //   } else {
  //     setGradeLevels([]);
  //     setKelasList([]);
  //   }
  // }, [props?.show, props?.id, props?.rowData, props?.nameUpdate]);

  useEffect(() => {
  if (!props?.show) return;

  const row = props?.rowData || {};

  const branchId = getBranchFromRow(row) || props?.branchId || "";
  const selectedGradeIds = getSelectedGradeFromRow(row);
  const selectedKelasIds = getSelectedKelasFromRow(row);
  const selectedMatpelId = getMatpelIdFromRow(row);

  setForm({
    ysb_branch_id: branchId,
    name_matpel: selectedMatpelId,
    ysb_grade_level_id: selectedGradeIds,
    ysb_kelas_id: selectedKelasIds,
    user_id: "",
  });

  if (branchId) {
    getGradeLevelsAndKelas(branchId);
    GetResponseMatpels(branchId);
  } else {
    setGetMatpel([]);
    setGradeLevels([]);
    setKelasList([]);
  }
}, [props?.show, props?.id, props?.rowData, props?.branchId]);

  // const handleChange = async (e) => {
  //   const { name, value } = e.target;

  //   if (name === "ysb_branch_id") {
  //     setForm((prev) => ({
  //       ...prev,
  //       ysb_branch_id: value,
  //       ysb_grade_level_id: [],
  //       ysb_kelas_id: [],
  //     }));

  //     getGradeLevelsAndKelas(value);
  //     return;
  //   }

  //   setForm((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };

  const handleChange = async (e) => {
    const { name, value } = e.target;

    // if (name === "ysb_branch_id") {
    //   setForm((prev) => ({
    //     ...prev,
    //     ysb_branch_id: value,
    //     ysb_grade_level_id: [],
    //     ysb_kelas_id: [],
    //   }));

    //   getGradeLevelsAndKelas(value);
    //   return;
    // }

    if (name === "ysb_branch_id") {
      setForm((prev) => ({
        ...prev,
        ysb_branch_id: value,
        name_matpel: "",
        ysb_grade_level_id: [],
        ysb_kelas_id: [],
      }));

      setGetMatpel([]);

      getGradeLevelsAndKelas(value);
      GetResponseMatpels(value);

      return;
    }

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const getKelasByGradeId = (gradeId) => {
    return kelasList.filter((kelas) => String(getGradeIdFromKelas(kelas)) === String(gradeId));
  };

  const handleCheckTingkatan = (gradeId) => {
    setForm((prev) => {
      const kelasDalamTingkatan = getKelasByGradeId(gradeId).map(
        (kelas) => kelas?.id
      );

      const isChecked = prev.ysb_grade_level_id.some(
        (id) => String(id) === String(gradeId)
      );

      if (isChecked) {
        return {
          ...prev,
          ysb_grade_level_id: prev.ysb_grade_level_id.filter(
            (id) => String(id) !== String(gradeId)
          ),
          ysb_kelas_id: prev.ysb_kelas_id.filter(
            (id) => !kelasDalamTingkatan.some((kelasId) => String(kelasId) === String(id))
          ),
        };
      }

      return {
        ...prev,
        ysb_grade_level_id: [...prev.ysb_grade_level_id, gradeId],
        ysb_kelas_id: Array.from(
          new Set([...prev.ysb_kelas_id, ...kelasDalamTingkatan])
        ),
      };
    });
  };

  const handleCheckKelas = (kelasId, gradeId) => {
    setForm((prev) => {
      const isChecked = prev.ysb_kelas_id.some(
        (id) => String(id) === String(kelasId)
      );

      const newKelasId = isChecked
        ? prev.ysb_kelas_id.filter((id) => String(id) !== String(kelasId))
        : [...prev.ysb_kelas_id, kelasId];

      const kelasDalamTingkatan = getKelasByGradeId(gradeId).map(
        (kelas) => kelas?.id
      );

      const stillHasSelectedKelasInGrade = kelasDalamTingkatan.some((id) =>
        newKelasId.some((selectedId) => String(selectedId) === String(id))
      );

      const newGradeLevelId = stillHasSelectedKelasInGrade
        ? Array.from(new Set([...prev.ysb_grade_level_id, gradeId]))
        : prev.ysb_grade_level_id.filter((id) => String(id) !== String(gradeId));

      return {
        ...prev,
        ysb_kelas_id: newKelasId,
        ysb_grade_level_id: newGradeLevelId,
      };
    });
  };

  // const handleSubmit = useMutation(async (e) => {
  //   e.preventDefault();

  //   if (!form?.ysb_branch_id) {
  //     ToastError.fire({
  //       icon: "error",
  //       title: "Cabang wajib dipilih",
  //     });
  //     return;
  //   }

  //   if (!form?.name_matpel?.trim()) {
  //     ToastError.fire({
  //       icon: "error",
  //       title: "Nama mata pelajaran wajib diisi",
  //     });
  //     return;
  //   }

  //   if (!form?.ysb_kelas_id || form.ysb_kelas_id.length === 0) {
  //     ToastError.fire({
  //       icon: "error",
  //       title: "Pilih minimal satu kelas",
  //     });
  //     return;
  //   }

  //   setIsSubmitting(true);

  //   try {
  //     const payload = {
  //       ysb_branch_id: form?.ysb_branch_id,
  //       name_matpel: form?.name_matpel,
  //       state_form: 1,
  //       user_id: id_user,

  //       // mengikuti payload add matpel
  //       grade_level_ids: form?.ysb_kelas_id,
  //     };

  //     const response = await APISD.put(
  //       `/api/matpels/${props.id}`,
  //       payload,
  //       fetchParams
  //     );

  //     if (response.status === 200 || response.status === 201) {
  //       ToastSuccess.fire({
  //         icon: "success",
  //         title: response.data.message || "Data berhasil diperbarui",
  //       });

  //       props.GetResponseData();
  //       props.onHide();
  //     }
  //   } catch (error) {
  //     console.error("Gagal memperbarui mata pelajaran:", error?.response || error);

  //     ToastError.fire({
  //       icon: "error",
  //       title:
  //         error.response?.data?.message ||
  //         "Gagal memperbarui mata pelajaran",
  //     });
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // });


//   const handleSubmit = useMutation(async (e) => {
//   e.preventDefault();

//   const selectedUserId =
//     id_user || localStorage.getItem("user_id") || localStorage.getItem("id");

//   const selectedAcademicYearId =
//     props?.academicYearId ||
//     props?.rowData?.ysb_academic_year_id ||
//     props?.rowData?.academic_year_id;

//   // const selectedConfigId =
//   //   props?.id ||
//   //   props?.rowData?.id ||
//   //   props?.rowData?.ysb_config_matpel_id ||
//   //   props?.rowData?.config_matpel_id;

//   // if (!selectedConfigId) {
//   //   ToastError.fire({
//   //     icon: "error",
//   //     title: "ID config mata pelajaran belum tersedia",
//   //   });
//   //   return;
//   // }

//   if (!selectedAcademicYearId) {
//     ToastError.fire({
//       icon: "error",
//       title: "Tahun ajaran belum tersedia",
//     });
//     return;
//   }

//   if (!form?.ysb_branch_id) {
//     ToastError.fire({
//       icon: "error",
//       title: "Cabang wajib dipilih",
//     });
//     return;
//   }

//   if (!form?.name_matpel) {
//     ToastError.fire({
//       icon: "error",
//       title: "Mata pelajaran wajib dipilih",
//     });
//     return;
//   }

//   if (!form?.ysb_kelas_id || form.ysb_kelas_id.length === 0) {
//     ToastError.fire({
//       icon: "error",
//       title: "Pilih minimal satu kelas",
//     });
//     return;
//   }

//   if (!selectedUserId) {
//     ToastError.fire({
//       icon: "error",
//       title: "User ID belum tersedia. Silakan login ulang.",
//     });
//     return;
//   }

//   setIsSubmitting(true);

//   try {
//     const payload = {
//       // id: selectedConfigId,
//       // ysb_config_matpel_id: selectedConfigId,
//       ysb_academic_year_id: selectedAcademicYearId,
//       ysb_branch_id: form.ysb_branch_id,
//       // ysb_matpel_id: Array.isArray(form.name_matpel)
//       //   ? form.name_matpel
//       //   : [form.name_matpel],
//       ysb_matpel_id: [form.name_matpel],
//       ysb_kelas_id: form.ysb_kelas_id,
//       user_id: selectedUserId,
//     };

//     console.log("PAYLOAD UPDATE CONFIG MATPEL:", payload);

//     const response = await APISD.put(
//       "/api/config-matpels/update",
//       payload,
//       fetchParams
//     );

//     console.log("RESPONSE UPDATE CONFIG MATPEL:", response?.data);

//     if (
//       response?.status === 200 ||
//       response?.status === 201 ||
//       response?.data?.status === 200 ||
//       response?.data?.status === 201
//     ) {
//       if (response?.data?.error === false || response?.data?.error === undefined) {
//         ToastSuccess.fire({
//           icon: "success",
//           title:
//             response?.data?.message ||
//             "Konfigurasi mata pelajaran berhasil diperbarui",
//         });

//         props.GetResponseData?.();
//         props.onHide?.();

//         return;
//       }
//     }

//     ToastError.fire({
//       icon: "error",
//       title:
//         response?.data?.message ||
//         "Gagal memperbarui konfigurasi mata pelajaran",
//     });
//   } catch (error) {
//     console.error("ERROR UPDATE CONFIG MATPEL:", error);
//     console.error("ERROR RESPONSE:", error?.response?.data);

//     ToastError.fire({
//       icon: "error",
//       title:
//         error?.response?.data?.message ||
//         "Gagal memperbarui konfigurasi mata pelajaran",
//     });
//   } finally {
//     setIsSubmitting(false);
//   }
// });

const getSchoolIdFromKelas = (kelas) => {
  return (
    kelas?.ysb_school_id ||
    kelas?.school_id ||
    kelas?.school?.id ||
    ""
  );
};

const getSelectedKelasDetail = () => {
  return kelasList.filter((kelas) =>
    form?.ysb_kelas_id?.some(
      (selectedId) => String(selectedId) === String(kelas?.id)
    )
  );
};

const getSchoolAndGradeFromSelectedKelas = () => {
  const selectedKelas = getSelectedKelasDetail();

  const firstKelas = selectedKelas?.[0];

  return {
    ysb_school_id: getSchoolIdFromKelas(firstKelas),
    ysb_grade_level_id:
      getGradeIdFromKelas(firstKelas) ||
      form?.ysb_grade_level_id?.[0] ||
      "",
  };
};

const handleSubmit = useMutation(async (e) => {
  e.preventDefault();

  const selectedUserId =
    id_user || localStorage.getItem("user_id") || localStorage.getItem("id");

  const selectedAcademicYearId =
    props?.academicYearId ||
    props?.rowData?.ysb_academic_year_id ||
    props?.rowData?.academic_year_id;

  if (!selectedAcademicYearId) {
    ToastError.fire({
      icon: "error",
      title: "Tahun ajaran belum tersedia",
    });
    return;
  }

  if (!form?.ysb_branch_id) {
    ToastError.fire({
      icon: "error",
      title: "Cabang wajib dipilih",
    });
    return;
  }

  if (!form?.name_matpel) {
    ToastError.fire({
      icon: "error",
      title: "Mata pelajaran wajib dipilih",
    });
    return;
  }

  if (!form?.ysb_kelas_id || form.ysb_kelas_id.length === 0) {
    ToastError.fire({
      icon: "error",
      title: "Pilih minimal satu kelas",
    });
    return;
  }

  if (!selectedUserId) {
    ToastError.fire({
      icon: "error",
      title: "User ID belum tersedia. Silakan login ulang.",
    });
    return;
  }

  const { ysb_school_id, ysb_grade_level_id } =
  getSchoolAndGradeFromSelectedKelas();

if (!ysb_school_id) {
  ToastError.fire({
    icon: "error",
    title: "School ID belum tersedia dari data kelas",
  });
  return;
}

if (!ysb_grade_level_id) {
  ToastError.fire({
    icon: "error",
    title: "Grade level ID belum tersedia dari data kelas",
  });
  return;
}

  setIsSubmitting(true);

  try {
    // const payload = {
    //   ysb_academic_year_id: selectedAcademicYearId,
    //   ysb_branch_id: form.ysb_branch_id,

    //   // wajib array, isinya ID matpel, bukan nama matpel
    //   // ysb_matpel_id: Array.isArray(form.name_matpel)
    //   //   ? form.name_matpel
    //   //   : [form.name_matpel],
    //   ysb_matpel_id: form.name_matpel,

    //   // langsung array kelas, tidak perlu id config
    //   ysb_kelas_id: form.ysb_kelas_id,

    //   user_id: selectedUserId,
    // };

    const payload = {
  ysb_academic_year_id: selectedAcademicYearId,
  ysb_branch_id: form.ysb_branch_id,
  ysb_school_id: ysb_school_id,
  ysb_grade_level_id: ysb_grade_level_id,
  ysb_matpel_id: form.name_matpel,
  ysb_kelas_id: form.ysb_kelas_id,
  user_id: selectedUserId,
};

    console.log("PAYLOAD UPDATE KELAS CONFIG MATPEL:", payload);

    const response = await APISD.put(
      "/api/config-matpels/update",
      payload,
      fetchParams
    );

    console.log("RESPONSE UPDATE KELAS CONFIG MATPEL:", response?.data);

    const isSuccess =
      response?.status === 200 ||
      response?.status === 201 ||
      response?.data?.status === 200 ||
      response?.data?.status === 201;

    if (isSuccess && (response?.data?.error === false || response?.data?.error === undefined)) {
      ToastSuccess.fire({
        icon: "success",
        title:
          response?.data?.message ||
          "Konfigurasi kelas mata pelajaran berhasil diperbarui",
      });

      props.GetResponseData?.();
      props.onHide?.();

      return;
    }

    ToastError.fire({
      icon: "error",
      title:
        response?.data?.message ||
        "Gagal memperbarui konfigurasi kelas mata pelajaran",
    });
  } catch (error) {
    console.error("ERROR UPDATE KELAS CONFIG MATPEL:", error);
    console.error("ERROR RESPONSE:", error?.response?.data);

    ToastError.fire({
      icon: "error",
      title:
        error?.response?.data?.message ||
        "Gagal memperbarui konfigurasi kelas mata pelajaran",
    });
  } finally {
    setIsSubmitting(false);
  }
});
  return (
    <Modal
      {...props}
      size="lg"
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="module-modal-dialog module-modal-dialog-lg"
      contentClassName="module-modal-content"
    >
      <style>{css}</style>

      <Form onSubmit={(event) => handleSubmit.mutate(event)}>
        <div className="module-modal-header">
          <div>
            <h5 className="module-modal-title">Update Matpel Kelas</h5>
            
          </div>

          <button
            type="button"
            className="module-modal-close"
            onClick={props.onHide}
            disabled={isSubmitting}
            aria-label="Tutup modal"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        <Modal.Body className="module-modal-body mt-1 mx-2">
          <div className="module-form-grid">
            <div className="module-form-group">
              <label className="module-form-label" htmlFor="update-branch">
                Cabang <span>*</span>
              </label>

              <select
                id="update-branch"
                className="module-form-select"
                onChange={handleChange}
                name="ysb_branch_id"
                value={ysb_branch_id}
                disabled
              >
                <option value="" hidden>
                  Pilih Cabang
                </option>

                {getDataCabang.map((cabang, index) => (
                  <option key={index} value={cabang?.branch_code}>
                    {cabang?.branch_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="module-form-group">
              <label className="module-form-label" htmlFor="update-matpel">
                Mata Pelajaran <span>*</span>
              </label>

              <select
                id="update-matpel"
                className="module-form-select"
                onChange={handleChange}
                name="name_matpel"
                value={name_matpel}
                disabled
              >
                <option value="" hidden>
                  Pilih Mata Pelajaran
                </option>

                {getDataMatpel.map((matpel, index) => (
                  <option key={index} value={matpel?.id}>
                    {matpel?.name_matpel}
                  </option>
                ))}
              </select>
            </div>

            <div className="module-form-group module-form-span-2">
              <label className="module-form-label">
                Tingkatan dan Kelas <span>*</span>
              </label>

              <div className="matpel-grade-panel">
                {!ysb_branch_id ? (
                  <div className="matpel-form-helper">
                    Cabang belum tersedia.
                  </div>
                ) : loading ? (
                  <div className="matpel-form-helper">
                    Memuat data tingkatan dan kelas...
                  </div>
                ) : gradeLevels.length === 0 ? (
                  <div className="matpel-form-helper">
                    Tingkatan tidak ditemukan untuk cabang ini.
                  </div>
                ) : (
                  <div className="tingkatan-kelas-wrapper">
                    {gradeLevels.map((tingkatan) => {
                      const gradeId = tingkatan?.id;
                      const kelasByGrade = getKelasByGradeId(gradeId);

                      return (
                        <div className="tingkatan-box" key={gradeId}>
                          <label className="tingkatan-parent">
                            <input
                              type="checkbox"
                              disabled={isSubmitting}
                              checked={ysb_grade_level_id.some(
                                (selectedId) =>
                                  String(selectedId) === String(gradeId)
                              )}
                              onChange={() => handleCheckTingkatan(gradeId)}
                            />
                            <span>Kelas {tingkatan?.name_level}</span>
                          </label>

                          {kelasByGrade.length > 0 && (
                            <div className="kelas-child-wrapper">
                              {kelasByGrade.map((kelas) => (
                                <label className="kelas-child" key={kelas?.id}>
                                  <input
                                    type="checkbox"
                                    disabled={isSubmitting}
                                    checked={ysb_kelas_id.some(
                                      (selectedId) =>
                                        String(selectedId) === String(kelas?.id)
                                    )}
                                    onChange={() =>
                                      handleCheckKelas(kelas?.id, gradeId)
                                    }
                                  />
                                  <span>
                                    {tingkatan?.name_level}{" "}
                                    {toTitleCase(getKelasName(kelas))}
                                  </span>
                                </label>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>

        <div className="module-modal-footer">
          <button
            type="button"
            className="module-modal-cancel"
            onClick={props.onHide}
            disabled={isSubmitting}
          >
            Batal
          </button>

          <button
            type="submit"
            className="module-modal-submit"
            disabled={
              isSubmitting ||
              loading ||
              !ysb_branch_id ||
              !name_matpel?.trim() ||
              ysb_kelas_id.length === 0
            }
          >
            {isSubmitting && <span className="module-button-spinner" />}
            {isSubmitting ? "Memperbarui..." : "Perbarui"}
          </button>
        </div>
      </Form>
    </Modal>
  );
}
